import { InputError } from './InputError';
import Moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

// @ts-ignore
import getOrientedImage from 'exif-orientation-image';
import Axios from 'axios';

export class Utils {

  public static DATE_PICKER_LANG: any = {
    days: ['月', '火', '水', '木', '金', '土', '日'],
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  };

  public static loadFieldErrors(errors: any[], inputErrors: InputError[]) {
    errors.forEach((err: any) => {
      const inputError = inputErrors.find((e) => e.field === err.field);
      if (inputError !== undefined) {
        if (inputError.isError === undefined) {
          inputError.isError = false;
          inputError.message = [];
        }
        inputError.message.push(err.defaultMessage);
      }
    });
  }

  public static getImage(image: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(image);      
      img.onload = () => {     
        const canvas = document.createElement('canvas');
        let max_size = (window.innerHeight > window.innerWidth ? window.innerWidth : window.innerHeight)*8/10;
        let width = img.width;
        let height = img.height;
        if (width > height) {
          if (width > max_size) {
            height *= max_size / width;
            width = max_size;
          }
        } else {
          if (height > max_size) {
            width *= max_size / height;
            height = max_size;
          }
        }
        canvas.width = width;
        canvas.height = height;
        let context = canvas.getContext('2d');
        if (!context) {
          resolve('');
          return;
        }
        context.drawImage(img, 0, 0, width, height);      
        // resolve(canvas.toDataURL());
        canvas.toBlob(function(blob: any) { resolve(blob); }, image.type, 1);
      };
    });
  }

  public static getRotatedImage(image: File): Promise<any> {
    return new Promise((resolve, reject) => {
      getOrientedImage(image, function(err: any, canvas: any) {
        if (!err) {
          canvas.toBlob(function(blob: any) { resolve(blob); }, image.type, 1);
        }
      });
    }).then((orientedImageBlob: any) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(orientedImageBlob);      
        img.onload = () => {     
          const canvas = document.createElement('canvas');
          let max_size = (window.innerHeight > window.innerWidth ? window.innerWidth : window.innerHeight)*8/10;
          let width = img.width;
          let height = img.height;
          if (width > height) {
            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }
          } else {
            if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
          }
          canvas.width = width;
          canvas.height = height;
          let context = canvas.getContext('2d');
          if (!context) {
            resolve('');
            return;
          }
          context.drawImage(img, 0, 0, width, height);      
          // resolve(canvas.toDataURL());
          canvas.toBlob(function(blob: any) { resolve(blob); }, image.type, 1);
        };
      });
    });
  }

  public static async convertUrlToBase64 ( url: any) {
    return Axios.get(url, { responseType: 'blob' })
      .then(response => {
        if (response.data) {
          const blob = new Blob([response.data], { type: 'image/png' })
          return blob
        }
        return null;
      }).catch(console.error)
  }

  public static getQueryParam(param?: string | null | Array<(string | null)>): string {
    if (param) {
      return (typeof param === 'string') ? param : this.getQueryParam(param[0]);
    }
    return '';
  }

  public static getDate(date: Date): string {
    return date ? Moment(date).format('YYYY-MM-DD') : '';
  }

  public static getDateTime(dateTime: number): string {
    return dateTime ? Moment(dateTime).format('YYYY-MM-DD HH:mm') : '';
  }

  public static checkNumberHalfsize(str: string): boolean {
    const reg = new RegExp('^[\\d]+$');
    if (str.match(reg)) {
      return true;
    }
    return false;
  }

  public static keypressNumber($event: any, length?: number) {
    const charCode = (typeof $event.which === 'number') ? $event.which : $event.keyCode;
    const regex: RegExp = /^\d*\.?\d*$/;
    if (regex.test(String.fromCharCode(charCode))) {
      if (length && $event.target.value.length >= length
        && ($event.target.selectionEnd - $event.target.selectionStart) === 0) {
        $event.preventDefault();
        return false;
      }
      return true;
    }
    $event.preventDefault();
    return false;
  }
}
